import { render, staticRenderFns } from "./ispprove.vue?vue&type=template&id=e040bd9e&scoped=true"
import script from "./ispprove.vue?vue&type=script&lang=js"
export * from "./ispprove.vue?vue&type=script&lang=js"
import style0 from "./ispprove.vue?vue&type=style&index=0&id=e040bd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e040bd9e",
  null
  
)

export default component.exports